export default __webpack_public_path__ + "static/dist_top_header-4bea263d62231a7bba83bfdf80f0d4f0.png";